import { HttpClient } from '../HttpClient';
/**
 * * Post Attendance Logs
 */
export const PostAttendanceLogs = async (params) => {
  try {
    const { data } = await HttpClient.post(`api/attendanceLogs/searchCriteria`, { ...params });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
